import React from 'react'


const ServicesPage = () => {
    return (
        <div>
            <h1>Blog</h1>
        </div>
    )
}

export default ServicesPage;
